import * as React from "react";
import {useEffect, useState} from "react";
import {useTheme} from "@mui/material/styles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {useNavigate} from "react-router-dom";
import numberToWord from "number-to-words-indian-currency";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import {Alert, AppBar, Card, TextField} from "@mui/material";
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import MDButton from "components/MDButton";
import dayjs from "dayjs";
import {DemoContainer} from "@mui/x-date-pickers/internals/demo";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {POST, GET, PATCH} from "APIclient";
import Snackbar from "@mui/material/Snackbar";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {useLocation} from "react-router-dom";
import properties from "constants/ApplicationConstants";

function IssueAppoinmentLetter(props) {
  const location = useLocation();
  const [usersState, setUsersState] = useState(location.state);
  const theme = useTheme();
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState(null);
  const [snakColor, setSnakColor] = React.useState("");
  const [snakMessage, setSnakMessage] = React.useState("");
  const handleCloseSnackbar = () => setSnackbar(null);
  const [hrManager, setHrManager] = useState([]);
  const [isIssueButtonEnabled, setIssueButtonEnabled] = React.useState(false);

  const [errors, setErrors] = useState({
    emailAddress: "",
    userName: ""
  });

  let [formData, setFormData] = React.useState({
    offerLetterId: "",
    empId: "",
    salutation: "",
    firstName: "",
    middleName: "",
    lastName: "",
    emailId: "",
    mobileNo: "",
    joinDate: dayjs(null),
    joinType: "",
    issuedBy: "",
    salary: "",
    emailAddress: "",
    ctcInWords: "",
    variableAmount: "",
    performanceBonus: "",
    reimburseAmount: "",
    joiningBonus: "",
    joiningBonusInWords: "",
    reimburseAmountInWords: "",
    variableAmountInWords: "",
    performanceBonusInWords: "",
    variablePayReason: "",
    appointmentIssuedBy: 2,
    addedOn: dayjs(null),
    cancelReason: "",
    password: "bntsoft@12",
    status: 1,
    userName: ""
  });

  React.useEffect(() => {
    setUsersState(props);
  }, [props]);

  React.useEffect(() => {
    const fetchUrl = `admin/getIssuedOfferList?offer_id=${usersState}`;
    const fetchData = async () => {
      try {
        const response = await GET(fetchUrl);
        let offerData = response?.data;
        setFormData(offerData);
        if (offerData?.salary) {
          const salaryInWords = convertSalaryToWords(offerData.salary);
          setFormData(prevFormData => ({
            ...prevFormData,
            ctcInWords: salaryInWords
          }));
        }
        if (offerData?.performanceBonus) {
          const performanceBonusInWords = convertSalaryToWords(offerData.performanceBonus);
          setFormData(prevFormData => ({
            ...prevFormData,
            performanceBonusInWords: performanceBonusInWords
          }));
        }
        if (offerData?.variableAmount) {
          const variableAmountInWords = convertSalaryToWords(offerData.variableAmount);
          setFormData(prevFormData => ({
            ...prevFormData,
            variableAmountInWords: variableAmountInWords
          }));
        }
        if (offerData?.reimburseAmount) {
          const reimburseAmountInWords = convertSalaryToWords(offerData.reimburseAmount);
          setFormData(prevFormData => ({
            ...prevFormData,
            reimburseAmountInWords: reimburseAmountInWords
          }));
        }
        if (offerData?.joiningBonus) {
          const joiningBonusInWords = convertSalaryToWords(offerData?.joiningBonus);
          setFormData(prevFormData => ({
            ...prevFormData,
            joiningBonusInWords: joiningBonusInWords
          }));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [usersState]);

  const handleChange = e => {
    const {name, value} = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (name === "salary") {
      const salaryValue = value;
      setFormData(prevState => ({
        ...prevState,
        [name]: salaryValue
      }));
      const salaryInWords = convertSalaryToWords(salaryValue);
      setFormData(prevState => ({
        ...prevState,
        ctcInWords: salaryInWords
      }));
    }

    if (name === "otherDesignation") {
      setFormData(prevState => ({
        ...prevState,
        otherDesignation: value
      }));
    }

    const error = validateField(name, value);
    setErrors(prev => ({...prev, [name]: error}));
  };

  const convertSalaryToWords = salary => {
    if (!salary || isNaN(salary)) {
      return "";
    }
    const words = numberToWord(salary);
    return words.charAt(0).toUpperCase() + words.slice(1);
  };

  const handleDateChange = (date, field) => {
    const validDate = date ? dayjs(date) : null;
    setFormData(prev => ({
      ...prev,
      [field]: validDate?.isValid() ? validDate.format("YYYY-MM-DD") : null
    }));
  };

  const handleClose = () => {
    setOpen(false);
  };

  const numberToWords = num => {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen"
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety"
    ];
    const thousands = ["", "Thousand", "Lakh", "Crore"];

    if (num === 0) return "Zero";

    let words = "";
    let i = 0;

    while (num > 0) {
      if (num % 1000 !== 0) {
        words = `${convertHundreds(num % 1000)} ${thousands[i]} ${words}`;
      }
      num = Math.floor(num / 1000);
      i++;
    }

    return words.trim();
  };

  const convertHundreds = num => {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen"
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety"
    ];

    if (num === 0) return "";
    if (num < 20) return ones[num];
    else if (num < 100) return `${tens[Math.floor(num / 10)]} ${ones[num % 10]}`;
    else return `${ones[Math.floor(num / 100)]} Hundred ${convertHundreds(num % 100)}`;
  };

  const validateField = (name, value) => {
    let errorMsg = "";
    const stringValue = value !== undefined && value !== null ? String(value) : "";

    if (name === "emailAddress") {
      if (!stringValue) {
        errorMsg = "Email is required";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        errorMsg = "Invalid email format";
      } else if (stringValue === formData.emailId) {
        errorMsg = "Official email ID cannot be the same as personal email ID";
      }
    } else if (name === "userName") {
      if (!stringValue.trim()) {
        errorMsg = "Username is required";
      }
    }

    setErrors(prev => ({...prev, [name]: errorMsg}));
    return errorMsg;
  };

  const handleSubmit = async () => {
    const emailError = validateField("emailAddress", formData.emailAddress);
    const usernameError = validateField("userName", formData.userName);

    if (emailError || usernameError) {
      return;
    }

    let url = `admin/issueOfferLetter/${formData.offerLetterId}`;
    const submitData = {
      empId: formData.empId,
      firstName: formData.firstName,
      middleName: formData.middleName,
      lastName: formData.lastName,
      emailAddress: formData.emailId,
      mobileNo: formData.mobileNo,
      appointDate: formData.joinDate,
      empType: formData.joinType,
      grossAmount: formData.salary,
      variableAmount: formData.variableAmount,
      performanceBonus: formData.performanceBonus,
      reimburseAmount: formData.reimburseAmount,
      variablePayReason: formData.variablePayReason,
      issuedBy: formData.issuedBy,
      officialEmailAddress: formData.emailAddress,
      username: formData.userName,
      password: "bntsoft@12"
    };

    try {
      let response = await PATCH(url, submitData);
      console.log("response", response);
      let dt = response?.data;
      if (dt?.statusCode == 200) {
        setSnakColor("success");
        setSnakMessage("Offer letter issued successfully.");
        setOpen(true);
        navigate("/Offer_List");
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        "An unexpected error occurred while issuing the offer letter.";
      setSnakColor("error");
      setSnakMessage(errorMsg);
      setOpen(true);
    }
  };

  React.useEffect(() => {
    const getUrl = `admin/hr-managers`;
    const getHrManager = async () => {
      try {
        const response = await GET(getUrl);
        const data = response?.data?.data;
        setHrManager(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    getHrManager();
  }, []);

  const parseAmount = value => parseFloat(value) || 0;
  const totalCTC =
    parseAmount(formData?.salary) +
    parseAmount(formData?.variableAmount) +
    parseAmount(formData?.performanceBonus) +
    parseAmount(formData?.joiningBonus);

  const totalSalaryInWords = convertSalaryToWords(totalCTC);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox container>
        <AppBar position="static">
          <Card>
            <MDBox
              pt={2}
              mb={0}
              pb={4}
              px={3}
              sx={{borderRadius: "5px", border: "1px solid #D3D3D3"}}
            >
              <InputLabel
                sx={{fontWeight: "bold", fontFamily: properties.fontFamily}}
                variant="h5"
                id="IssueAppoinmentLetter"
              >
                Issue Appointment Letter
              </InputLabel>
              <MDInput
                pattern="[0-9]*"
                min={0}
                disabled={true}
                sx={{m: 1, width: "25ch"}}
                name="empId"
                value={formData ? formData.empId : ""}
                type="text"
                label={
                  <span>
                    Employee ID <span style={{color: "red"}}>*</span>
                  </span>
                }
                variant="standard"
                onChange={e => handleChange(e)}
              />
            </MDBox>
            <MDBox
              pt={2}
              mb={0}
              pb={4}
              px={3}
              sx={{borderRadius: "5px", border: "1px solid #D3D3D3"}}
            >
              <InputLabel sx={{fontWeight: "bold"}} id="offerDate">
                Candidate Information
              </InputLabel>
              <MDInput
                sx={{m: 1, width: "20ch"}}
                name="firstName"
                value={formData ? formData.firstName : ""}
                type="text"
                label="First Name"
                variant="standard"
                onChange={e => handleChange(e)}
                InputProps={{readOnly: true}}
              />
              <MDInput
                sx={{m: 1, width: "20ch"}}
                name="middleName"
                value={formData ? formData.middleName : ""}
                type="text"
                label="Middle Name"
                variant="standard"
                onChange={e => handleChange(e)}
                InputProps={{readOnly: true}}
              />
              <MDInput
                sx={{m: 1, width: "20ch"}}
                name="lastName"
                value={formData ? formData.lastName : ""}
                type="text"
                label="Last Name"
                variant="standard"
                onChange={e => handleChange(e)}
                InputProps={{readOnly: true}}
              />
              <MDBox mt={1}>
                <MDInput
                  sx={{m: 1, width: "30ch"}}
                  type="email"
                  name="emailId"
                  value={formData ? formData.emailId : ""}
                  id="outlined-error"
                  onChange={e => handleChange(e)}
                  label="Email"
                  variant="standard"
                  InputProps={{readOnly: true}}
                />
                <MDInput
                  sx={{m: 1, width: "30ch"}}
                  type="text"
                  name="mobileNo"
                  label="Mobile"
                  value={formData ? formData.mobileNo : ""}
                  onChange={e => handleChange(e)}
                  variant="standard"
                  InputProps={{readOnly: true}}
                />
              </MDBox>
            </MDBox>
            <MDBox
              pt={2}
              mb={0}
              pb={4}
              px={3}
              sx={{borderRadius: "5px", border: "1px solid #D3D3D3"}}
            >
              <InputLabel sx={{fontWeight: "bold"}} id="other">
                Other Information
              </InputLabel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker", "Select"]} sx={{marginTop: "10px"}}>
                  <DatePicker
                    format="DD/MM/YYYY"
                    sx={{m: 1, width: "30ch"}}
                    size="small"
                    label={
                      <span>
                        Appointed On <span style={{color: "red"}}>*</span>
                      </span>
                    }
                    name="joinDate"
                    value={formData ? dayjs(formData.joinDate) : null}
                    onChange={date => handleDateChange(date, "joinDate")}
                    readOnly
                  />
                  <FormControl variant="standard" sx={{m: 1, width: "30ch"}}>
                    <InputLabel id="joinType">
                      <span>
                        Emp. Type <span style={{color: "red"}}>*</span>
                      </span>
                    </InputLabel>
                    <Select
                      value={formData ? formData.joinType : ""}
                      name="empType"
                      label="Emp. Type"
                      onChange={e => handleChange(e)}
                      IconComponent={ExpandMoreIcon}
                      sx={{
                        pointerEvents: "none",
                        backgroundColor: "inherit"
                      }}
                      open={false}
                    >
                      <MenuItem value="">
                        <em>Select</em>
                      </MenuItem>
                      <MenuItem value="Fresher">Fresher</MenuItem>
                      <MenuItem value="Experience">Experience</MenuItem>
                      <MenuItem value="Temporary">Temporary</MenuItem>
                      <MenuItem value="Consultant">Consultant</MenuItem>
                    </Select>
                  </FormControl>
                </DemoContainer>
              </LocalizationProvider>
              <MDBox mb={2} mr={4}>
                <MDInput
                  type="text"
                  name="salary"
                  label={
                    <span>
                      Fixed Salary <span style={{color: "red"}}>*</span>
                    </span>
                  }
                  value={formData?.salary}
                  onChange={e => handleChange(e)}
                  variant="standard"
                  sx={{m: 1, width: "25ch"}}
                  inputProps={{readOnly: true}}
                />
                <MDInput
                  type="text"
                  name="ctcInWords"
                  disabled
                  label="Fixed Salary In Words"
                  value={formData?.ctcInWords}
                  variant="standard"
                  sx={{m: 1, width: "55ch"}}
                />
              </MDBox>
              <MDBox mb={2} mr={4}>
                <InputLabel id="variableAmount" sx={{m: 1, width: "30ch", fontWeight: "bold"}}>
                  Variable Pay ( If Applicable )
                </InputLabel>
                <MDInput
                  type="text"
                  name="variableAmount"
                  label="Variable Amount "
                  value={formData ? formData.variableAmount : ""}
                  onChange={e => handleChange(e)}
                  variant="standard"
                  sx={{m: 1, width: "25ch"}}
                  inputProps={{readOnly: true}}
                />
                <MDInput
                  type="text"
                  name="variableAmountInWords"
                  label="Variable Amount In Words"
                  value={formData?.variableAmountInWords}
                  disabled
                  variant="standard"
                  sx={{m: 1, width: "55ch"}}
                />
              </MDBox>
              <MDBox mb={2} mr={4}>
                <MDInput
                  type="text"
                  name="performanceBonus"
                  label="Performance Bonus"
                  value={formData ? formData.performanceBonus : ""}
                  onChange={e => handleChange(e)}
                  variant="standard"
                  sx={{m: 1, width: "25ch"}}
                  inputProps={{readOnly: true}}
                />
                <MDInput
                  type="text"
                  name="performanceBonusInWords"
                  label="Performance Bonus In Words"
                  value={formData.performanceBonusInWords}
                  disabled
                  variant="standard"
                  sx={{m: 1, width: "55ch"}}
                />
              </MDBox>
              <MDBox mb={2} mr={4}>
                <MDInput
                  type="text"
                  name="joiningBonus"
                  label="Joining Bonus"
                  value={formData ? formData.joiningBonus : ""}
                  onChange={e => handleChange(e)}
                  variant="standard"
                  sx={{m: 1, width: "25ch"}}
                  inputProps={{readOnly: true}}
                />
                <MDInput
                  type="text"
                  name="joiningBonusInWords"
                  label="Joining Bonus In Words"
                  value={formData.joiningBonusInWords}
                  disabled
                  variant="standard"
                  sx={{m: 1, width: "55ch"}}
                />
              </MDBox>
              <MDBox mb={2} mr={4}>
                <MDInput
                  type="text"
                  name="totalCTC"
                  label="Total Salary (CTC)"
                  value={totalCTC && totalCTC !== 0 ? totalCTC : ""}
                  variant="standard"
                  sx={{m: 1, width: "25ch"}}
                  inputProps={{readOnly: true}}
                />
                <MDInput
                  type="text"
                  name="totalCTCInWords"
                  label="Total Salary In Words"
                  value={totalSalaryInWords}
                  variant="standard"
                  disabled
                  sx={{m: 1, width: "55ch"}}
                />
              </MDBox>
              <MDBox mb={2} mr={4}>
                <MDInput
                  type="text"
                  name="reimburseAmount"
                  label="Reimburse Amount"
                  value={formData?.reimburseAmount}
                  onChange={e => handleChange(e)}
                  variant="standard"
                  sx={{m: 1, width: "25ch"}}
                  inputProps={{readOnly: true}}
                />
                <MDInput
                  type="text"
                  name="reimburseAmountInWords"
                  label="Reimburse Amount In Words"
                  value={formData.reimburseAmountInWords}
                  disabled
                  variant="standard"
                  sx={{m: 1, width: "55ch"}}
                />
              </MDBox>
              <MDBox mb={2} mr={4}>
                <FormControl variant="standard" sx={{m: 1, width: "30ch"}}>
                  <InputLabel id="issuedBy" sx={{fontWeight: "bold"}}>
                    <span>
                      Issued By <span style={{color: "red"}}>*</span>
                    </span>
                  </InputLabel>
                  <Select
                    labelId="issuedBy"
                    id="issuedBy"
                    value={formData ? formData.issuedBy : ""}
                    name="issuedBy"
                    onChange={e => handleChange(e)}
                    label="Issued By"
                    sx={{
                      pointerEvents: "none",
                      backgroundColor: "inherit"
                    }}
                    open={false}
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    {hrManager?.map(manager => (
                      <MenuItem key={manager.empId} value={manager.empId}>
                        {`${manager.firstName} ${manager.lastName}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  sx={{width: "30ch"}}
                  type="email"
                  name="emailAddress"
                  value={formData.emailAddress ? formData.emailAddress : ""}
                  id="outlined-error"
                  onChange={e => handleChange(e)}
                  label={
                    <span>
                      Official Email ID <span style={{color: "red"}}>*</span>
                    </span>
                  }
                  variant="standard"
                  error={Boolean(errors.emailAddress)}
                  helperText={errors.emailAddress}
                />
              </MDBox>
              <MDBox mb={2} mr={4}>
                <TextField
                  sx={{m: 1, width: "30ch"}}
                  name="userName"
                  value={formData ? formData.userName : ""}
                  type="text"
                  label={
                    <span>
                      Username <span style={{color: "red"}}>*</span>
                    </span>
                  }
                  variant="standard"
                  onChange={e => handleChange(e)}
                  error={Boolean(errors.userName)}
                  helperText={errors.userName}
                />
              </MDBox>
            </MDBox>
            <MDBox mt={3} mb={2} sx={{display: "flex", justifyContent: "flex-end"}}>
              <MDBox sx={{display: "flex", gap: 2}}>
                <MDButton
                  variant="gradient"
                  color="warning"
                  sx={{width: "20ch"}}
                  onClick={() => navigate(-1)}
                >
                  Back
                </MDButton>
                <MDButton
                  variant="gradient"
                  color="info"
                  sx={{
                    marginRight: "10px",
                    width: "20ch",
                    fontFamily: properties.fontFamily,
                    background: properties.colors.bgcolorbluethem
                  }}
                  onClick={() => handleSubmit()}
                >
                  Issue
                </MDButton>
              </MDBox>
            </MDBox>
            <Snackbar
              open={open}
              anchorOrigin={{vertical: "top", horizontal: "right"}}
              autoHideDuration={6000}
              onClose={handleClose}
            >
              <Alert
                autoHideDuration={1200}
                onClose={handleClose}
                severity={snakColor == "success" ? "success" : "error"}
                variant="filled"
                sx={{width: "100%"}}
              >
                {snakMessage}
              </Alert>
            </Snackbar>
          </Card>
        </AppBar>
      </MDBox>
    </DashboardLayout>
  );
}

export default IssueAppoinmentLetter;
